import { mutateProjectPhases } from '../../mutations/mutateProjectPhases';
import { projectsAPI } from 'api/projects/endpoints';
import { PhaseAttribute } from 'api/projects/models';
import { serialize } from 'object-to-formdata';

export const updateProjectPhase = async (
  projectId: string,
  phaseId: string,
  params: PhaseAttribute,
) => {
  const formData = serialize({ phase: params });
  await projectsAPI.updateProjectPhase(projectId, phaseId, formData);

  await mutateProjectPhases();
};
